import {useAtom} from "jotai";
import {IInitialStateAtom, initialStateAtom} from "@/store";
import {useRouter} from "next/router";
import {useEffect} from "react";

/**
 * 공통 파라미터를 관리하는 커스텀 훅
 * 초기화된 공통 상태값 중 페이지 진입 후 지속적으로 변하는 것은 page뿐.
 */
const useCommonParams = (initialStateFromServer?: IInitialStateAtom): IInitialStateAtom => {
  const [initialState, setInitialState] = useAtom(initialStateAtom)
  const {query} = useRouter();

  useEffect(() => {
    if (initialStateFromServer) {
      setInitialState(initialStateFromServer)
    }
  }, [initialStateFromServer, setInitialState])
  const media = query.media ? query.media as string : '';
  const page = query.page ? query.page as string : 'collection';


  return {...initialState, media, page}
}

export default useCommonParams